import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '../lib/supabase'

export function AuthCallbackPage() {
  const navigate = useNavigate()
  const [status, setStatus] = useState('Completing sign in...')

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const tokenHash = params.get('token_hash')
    const type = params.get('type') as string | null

    if (tokenHash && type) {
      supabase.auth.verifyOtp({ token_hash: tokenHash, type: type as any }).then(({ data, error }) => {
        if (error) {
          setStatus(`Sign-in failed: ${error.message}`)
        } else if (data.session) {
          // Recovery links → prompt to set a password
          if (type === 'recovery') {
            navigate('/set-password', { replace: true })
          } else {
            navigate('/dashboard', { replace: true })
          }
        } else {
          setStatus('No session returned. Try signing in again.')
        }
      })
    } else {
      // Hash-based flow (some email clients strip query params)
      const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
        if (event === 'SIGNED_IN' && session) {
          navigate('/dashboard', { replace: true })
        }
      })
      return () => subscription.unsubscribe()
    }
  }, [navigate])

  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      <p>{status}</p>
    </div>
  )
}
